// extracted by mini-css-extract-plugin
export default {"wrapper":"header_wrapper__UEZWd","brand":"header_brand__lQQSF","rows":"header_rows__GGKEU","row1":"header_row1__Yh3jG","row2":"header_row2__gH2q+"};